module.exports = "/_next/static/images/817c5a10cff6810c5cbfd42e5f69b038-hero-lg.jpg.webp";